import { NewsType } from "../../../redux/news/newsSlice";
import axios from "../../apiFc24";

export type NewsResponse = NewsType[];

export const getNews = async () => {
  const res = await axios.get<NewsResponse>("/news");
  return res.data;
};
